/**
 * Onaylar (birleşik onay kutusu) tip tanımlamaları
 * Backend: GET /approvals/pending, GET /approvals/counts, PUT /approvals/:type/:id
 */

import { ApprovalFlowStepStatus } from './approval.types';

export type ApprovalType = 'leave' | 'overtime' | 'field_mode' | 'field_activity' | 'ticket';

export const APPROVAL_TYPES: ApprovalType[] = ['leave', 'overtime', 'field_mode', 'field_activity', 'ticket'];

export const APPROVAL_TYPE_LABELS: Record<ApprovalType, string> = {
  leave: 'İzinler',
  overtime: 'Fazla Mesai',
  field_mode: 'Saha Modu',
  field_activity: 'Aktivite Talepleri',
  ticket: 'Talepler',
};

export type ApprovalRejectReasonMode = 'required' | 'optional' | 'none';

export type ApprovalDetailKind = 'text' | 'date' | 'datetime';

export interface ApprovalRequester {
  id: number;
  firstName: string;
  lastName: string;
  profilePicture: string | null;
  gender: string | null;
  title: string | null;
  departmentName: string | null;
}

export interface ApprovalDetail {
  label: string;
  value: string | number | null;
  kind: ApprovalDetailKind;
}

export interface ApprovalFlowItem {
  step: number;
  approverName: string;
  status: ApprovalFlowStepStatus;
}

export interface ApprovalItem {
  key: string;
  type: ApprovalType;
  id: number;
  title: string;
  description: string | null;
  requester: ApprovalRequester | null;
  createdAt: string;
  details: ApprovalDetail[];
  rejectReason: ApprovalRejectReasonMode;
  approvalFlow: ApprovalFlowItem[];
  documentUrl: string | null;
}

export interface ApprovalCountsResponse {
  counts: Record<ApprovalType, number>;
  total: number;
  failedTypes: ApprovalType[];
}

export interface ApprovalPendingResponse extends ApprovalCountsResponse {
  items: ApprovalItem[];
}

export interface ApprovalDecisionDTO {
  action: 'approve' | 'reject';
  reason?: string;
}

export interface ApprovalDecisionResponse {
  result: unknown;
  message: string;
}
